import React from "react";
import {
	BrowserRouter as Router,
	Route,
	Routes,
	Navigate,
} from "react-router-dom";
import Login from "./Pages/Login/Login";
import Home from "./Pages/Home/Home";
import Profile from "./Pages/Profile/Profile";
import Wrapper from "./Components/Wrapper/Wrapper";
import Accounts from "./Pages/Accounts/Accounts";
import Savings from "./Pages/Savings/Savings";
import SubAccounts from "./SubPages/SubAccounts/SubAccounts";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material";
import SubSavings from "./SubPages/SubSavings/SubSavings";
import SubHistory from "./SubPages/SubHistory/SubHistory";
import Registration from "./Pages/Registration/Registration";
import Admin from "./Pages/Admin/Admin";
import "./App.css";

const ProtectedRoute = ({ children }) => {
	const { currentUser } = useAuth();
	return currentUser ? children : <Navigate to="/login" />;
};

const theme = createTheme({
	palette: {
		mode: "dark",
		primary: {
			main: "#4B4F97", // фиолетовый оттенок для акцентов
		},
		secondary: {
			main: "#C0C0C0", // сероватый для второстепенных элементов
		},
		background: {
			default: "#1C1F2A", // темный синий фон
			paper: "#2B2E3A", // более светлый темный для карточек и модальных окон
		},
		text: {
			primary: "#FFFFFF", // основной белый текст
			secondary: "#A0A0A0", // серый текст для второстепенных элементов
		},
		success: {
			main: "#00FF00", // зеленый для положительного PNL
		},
		error: {
			main: "#FF0000", // красный для отрицательного PNL
		},
	},
	typography: {
		fontFamily: "Roboto, sans-serif",
	},
	components: {
		MuiDrawer: {
			styleOverrides: {
				paper: {
					background: "#14192d", // Отключаем градиент
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					background: "#14192d", // Устанавливаем однородный цвет вместо градиента
				},
			},
		},
	},
});

const App = () => {
	return (
		<ThemeProvider theme={theme}>
			<AuthProvider>
				<Router>
					<Routes>
						<Route path="/login" element={<Login />} />
						<Route path="/registration" element={<Registration />} />
						<Route
							path="/"
							element={
								<ProtectedRoute>
									<Wrapper />
								</ProtectedRoute>
							}
						>
							<Route index element={<Home />} />
							<Route path="/profile" element={<Profile />} />
							<Route path="/accounts" element={<Accounts />} />
							<Route path="/admin" element={<Admin />} />
							<Route path="/savings" element={<Savings />}>
								<Route path="/savings" element={<SubSavings />} />
								<Route path="accounts" element={<SubAccounts />} />
								<Route path="history" element={<SubHistory />} />
							</Route>
						</Route>
					</Routes>
				</Router>
			</AuthProvider>
		</ThemeProvider>
	);
};

export default App;
